module.exports = __webpack_public_path__ + "img/yiyao_p3_suoluetu.00fd43e1.png";